import { render } from "./Apia.vue?vue&type=template&id=73f657c6&scoped=true"
import script from "./Apia.vue?vue&type=script&lang=js"
export * from "./Apia.vue?vue&type=script&lang=js"

import "./Apia.vue?vue&type=style&index=0&id=73f657c6&scoped=true&lang=scss"

import exportComponent from "D:\\project\\pc\\website\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f657c6"]])

export default __exports__